export default __webpack_public_path__ + "static/media/questions-xl-2x.6ce91ad7.webp";